import { DB_DATE_FORMAT } from 'core/constants';
import { formatDateForServer } from 'core/utils';
import { IJob, IUpdateJobForm } from 'jobs/types';

export const mapUpdateBaseInformationForm = (data: IUpdateJobForm, job: IJob) => {
  return {
    bom: {
      id: job.id,
      corporateBomStatusId: data?.status?.id,
      externalLocationRegion: data?.externalLocationRegion,
      externalLocationCountry: data?.externalLocationCountry?.name,
      customerCompanyName: data?.customerCompanyName,
      customerNumber: data?.customerNumber,
      requestedByUserId: data?.requestedByUser?.userId || null,
      requestedByUserEmployeeId: data?.requestedByUserEmployeeId || null,
      supportUserId: data?.supportUser?.userId || null,
      disciplineId: data?.discipline?.id || null,
      requestedByDate: data?.dueDate ? formatDateForServer(data.dueDate, DB_DATE_FORMAT) : null,
      supportCompletedDate: data?.supportCompletedDate
        ? formatDateForServer(data.supportCompletedDate, DB_DATE_FORMAT)
        : null,
    },
  };
};
